import { Controller } from "@hotwired/stimulus"

// 日付 input + 時 select + 分 select (00/15/30/45) を組み合わせて
// hidden input に datetime-local 形式 (YYYY-MM-DDTHH:mm) の値を同期する。
export default class extends Controller {
  static targets = ["date", "hour", "minute", "hidden"]

  // 表示側 (date / hour / minute) → hidden への同期
  sync() {
    const date = this.dateTarget.value
    const hour = this.hourTarget.value
    const minute = this.minuteTarget.value
    let value = ""
    if (date && hour !== "" && minute !== "") {
      value = `${date}T${hour}:${minute}`
    }
    if (this.hiddenTarget.value !== value) {
      this.hiddenTarget.value = value
      this.hiddenTarget.dispatchEvent(new Event("input", { bubbles: true }))
      this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  // 外部 (モーダル open / リセット) から値をセットする
  setValue(value) {
    if (!value) {
      this.dateTarget.value = ""
      this.hourTarget.value = ""
      this.minuteTarget.value = ""
      this.hiddenTarget.value = ""
      return
    }
    const [datePart, timePart] = value.split("T")
    this.dateTarget.value = datePart || ""
    if (timePart) {
      const [h, m] = timePart.split(":")
      this.hourTarget.value = h || ""
      const minutes = parseInt(m, 10)
      if (!isNaN(minutes)) {
        let rounded = Math.round(minutes / 15) * 15
        if (rounded >= 60) rounded = 0
        this.minuteTarget.value = String(rounded).padStart(2, "0")
      } else {
        this.minuteTarget.value = ""
      }
    } else {
      this.hourTarget.value = ""
      this.minuteTarget.value = ""
    }
    this.hiddenTarget.value = value
  }
}
